import { TCreateSubcategoryAction, CreateSubcategoryActionTypes } from './createSubcategoryActions';
import { ICreateSubcategoryState } from './createSubcategoryContext';

export const createSubcategoryReducer = (
	state: ICreateSubcategoryState,
	action: TCreateSubcategoryAction,
): ICreateSubcategoryState => {
	switch (action.type) {
		case CreateSubcategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateSubcategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				fetchedRestaurants: [],
				fetchedCategories: [],
			};
		case CreateSubcategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDSelectedCategory: null,
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateSubcategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateSubcategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case CreateSubcategoryActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case CreateSubcategoryActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				IDsSelectedRestaurant: [],
			};
		case CreateSubcategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY:
			return {
				...state,
				nameOfSubcategory: action.payload.nameOfSubcategory,
			};
		case CreateSubcategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case CreateSubcategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateSubcategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateSubcategoryActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateSubcategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateSubcategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateSubcategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateSubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateSubcategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDSelectedCategory: null,
				nameOfSubcategory: '',
				hasSchedulePriority: false,
				activationSchedule: '',
				deactivationSchedule: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
